import { emitAnalyticsEvent } from '@/lib/analyticsClient';

// Sparse, first-party events. No PCM, URLs, emails or per-frame samples.
export function arcadeTelemetry(
  kind: string,
  game: string,
  trackName: string,
  details: Record<string, string | number | boolean> = {}
) {
  emitAnalyticsEvent({
    eventName: 'arcade_diagnostic',
    eventCategory: 'arcade',
    trackName,
    metadata: { target: `arcade:diagnostic:${kind}`, game, ...details },
    immediate: kind === 'exit',
  });
}
